<template>
  <div id="academy">
    <div class="academy-setting">
      <div class="btn">
        <a-button
          class="btn-item"
          size="large"
          type="primary"
          icon="rollback"
          @click="back()"
        >
          返回
        </a-button>
        <a-button
          class="btn-item"
          icon="retweet"
          size="large"
          type="primary"
          @click="reset()"
        >
          重置位置
        </a-button>
      </div>
      <div class="spotlight_item">
        <div class="spotlight-item-slider">
          <div>
            光照强度
          </div>
          <div class="slider-item">
            <a-slider v-model="spotLight.intensity" :min="0" :max="20" />
          </div>
          <div>
            <a-input-number
              v-model="spotLight.intensity"
              :min="0"
              :max="20"
              style="marginLeft: 16px"
            />
          </div>
        </div>
        <div class="spotlight-item-slider">
          <div>
            光照x
          </div>
          <div class="slider-item">
            <a-slider v-model="spotLight.position.x" :min="0" :max="300" />
          </div>
          <div>
            <a-input-number
              v-model="spotLight.position.x"
              :min="0"
              :max="300"
              style="marginLeft: 16px"
            />
          </div>
        </div>
        <div class="spotlight-item-slider">
          <div>
            光照y
          </div>
          <div class="slider-item">
            <a-slider v-model="spotLight.position.y" :min="0" :max="300" />
          </div>
          <div>
            <a-input-number
              v-model="spotLight.position.y"
              :min="0"
              :max="300"
              style="marginLeft: 16px"
            />
          </div>
        </div>
        <div class="spotlight-item-slider">
          <div>
            光照z
          </div>
          <div class="slider-item">
            <a-slider v-model="spotLight.position.z" :min="0" :max="300" />
          </div>
          <div>
            <a-input-number
              v-model="spotLight.position.z"
              :min="0"
              :max="300"
              style="marginLeft: 16px"
            />
          </div>
        </div>
        <!-- <div class="spotlight-item-slider">
          <div>
            自转速度
          </div>
          <div class="slider-item">
            <a-slider v-model="rotate.speed" :min="0" :max="10" />
          </div>
          <div>
            <a-input-number
              v-model="rotate.speed"
              :min="0"
              :max="10"
              style="marginLeft: 16px"
            />
          </div>
        </div> -->
        <!-- <div class="spotlight-item-slider">
          <div>
            <div>
              拖动
            </div>
            <div class="slider-item">
              <a-switch checked-children="开" un-checked-children="关" default-checked v-model="controls.staticMoving" @change="ctrlChange()"/>
            </div>
          </div>
          <div>
            <div>
              自转
            </div>
            <div class="slider-item">
              <a-switch checked-children="开" un-checked-children="关" default-checked v-model="rotate.switch"/>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <a-progress
      v-show="percent < 100"
      class="progress"
      type="circle"
      :percent="percent"
    />
  </div>
</template>

<script>
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { TrackballControls } from "three/examples/jsm/controls/TrackballControls";

export default {
  name: "academy",
  data() {
    return {
      scene: "",
      camera: "",
      orthographicCamera: "",
      renderer: "",
      requestId: "",
      spotLight: {
        intensity: "",
        distance: "",
        angle: "",
        penumbra: "",
        decay: "",
        position: {
          x: 0,
          y: 0,
          z: 0
        }
      },
      lightHelper: "",
      controls: {
        staticMoving: false
      },
      rotate: {
        switch: true,
        speed: 0.005
      },
      percent: 0,
      threeObj: undefined,
      boxHelper: "",
      frustumSize: 400,
      params: {
        orthographicCamera: false
      },
      threejsUrl: "https://image.v3.findeng.com/pdt3D/3620.glb"
    };
  },

  activated() {
    if (this.$route.query.threejsUrl != "null") {
      this.threejsUrl = this.$route.query.threejsUrl;
    }
    this.init();
    this.loadPlant();
    document.getElementsByTagName("canvas")[0].style.verticalAlign = "bottom"; //解决canvas底部留白问题
  },

  methods: {
    init() {
      this.initScene();
      this.initRenderer();
      this.initCamera();
      this.createControls(this.camera);
      //添加环境光
      this.initLight();
      // this.initGui();
    },
    back() {
      this.disposeChild(this.threeObj);
      this.container.removeChild(this.renderer.domElement);
      this.clearScene()
      this.$router.go(-1);

      // window.cancelAnimationFrame(this.requestId);
    },
    reset() {
      // this.createControls(this.camera);
      // this.afterLoadObject()
      this.$router.go(0);
      // location.reload()
    },
    clearScene() {
      cancelAnimationFrame(this.requestId);
      this.scene.traverse((child) => {
        if (child.material) {
          child.material.dispose();
        }
        if (child.geometry) {
          child.geometry.dispose();
        }
        child = null;
      });
      this.clearRenderer()
      this.scene.clear();
      this.flows = [];
      this.scene = null;
      this.camera = null;
      this.controls = null;
    },
    //强制清除模型
    disposeChild(mesh) {
      if (mesh instanceof THREE.Mesh) {
        if (mesh.geometry) {
          mesh.geometry.dispose(); //删除几何体
        }
        if (mesh.material.dispose) {
          mesh.material.dispose(); //删除材质
        }
        if (mesh.material.texture.dispose) {
          mesh.material.texture.dispose();
        }
      }
      if (mesh instanceof THREE.Group) {
        mesh.clear();
      }
      if (mesh instanceof THREE.Object3D) {
        mesh.clear();
      }
      new THREE.Cache.clear();
      this.scene.remove(this.threeObj);
      this.scene.clear();
    },

    clearRenderer() {
      this.renderer.dispose();
      this.renderer.renderLists.dispose();
      this.renderer.domElement = null;
      this.renderer = null;
    },
    /**初始化 */
    initScene() {
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color(0xABABAB);
      var axesHelper = new THREE.AxesHelper();
      this.scene.add(axesHelper);
    },

    //相机
    initCamera() {
      let aspect = document.body.clientWidth / document.body.clientHeight;
      this.camera = new THREE.PerspectiveCamera(40, aspect, 1, 1000);
      this.scene.add(this.camera);
    },
    //渲染器
    initRenderer() {
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(
        document.body.clientWidth
          ? document.body.clientWidth
          : window.innerWidth,
        document.body.clientHeight
          ? document.body.clientHeight
          : window.innerHeight
      );
      this.container = document.getElementById("academy");
      this.container.appendChild(this.renderer.domElement);
    },

    ctrlChange() {
      this.controls.update();
    },

    createControls() {
      this.controls = new TrackballControls(
        this.camera,
        this.renderer.domElement
      );
      this.controls.rotateSpeed = 7;
      this.controls.zoomSpeed = 2;
      //放大倍数区间
      this.controls.minDistance = 10;
      this.controls.maxDistance = 1000;
      this.controls.panSpeed = 0.5;
      this.controls.staticMoving = false;
      // this.controls.keys = [65, 83, 68];
    },

    onWindowResize() {
      var aspect = document.body.clientWidth / document.body.clientHeight;
      this.camera.aspect = aspect;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(
        document.body.clientWidth,
        document.body.clientHeight
      );
      this.controls.handleResize();
    },

    animate() {
      // if (this.threeObj && this.rotate.switch) {
      //   // this.threeObj.rotateY(this.rotate.speed);
      //   // this.threeObj.rotateOnAxis(new THREE.Vector3(0,1,0),Math.PI/4);
      //   // this.threeObj.rotateX(Math.PI/4);
      // }
      if (this.renderer) {
        this.renderer.render(this.scene, this.camera);
      }
      if (this.controls) {
        this.controls.update();
      }
      // this.lightHelper.update();
      this.requestId = requestAnimationFrame(this.animate);
    },

    loadPlant() {
      let that = this;
      // 创建立方体
      let gLTFLoader = new GLTFLoader();
      gLTFLoader.load(
        this.threejsUrl,
        object => {
          this.boxHelper = new THREE.Box3().setFromObject(object.scene);
          this.threeObj = object.scene;
          this.afterLoadObject();
          that.scene.add(object.scene);
          this.animate();
          window.addEventListener("resize", this.onWindowResize(), false);
        },
        xhr => {
          this.percent = ((xhr.loaded / xhr.total) * 100).toFixed(0);
        }
      );
    },

    afterLoadObject() {
      let that = this;
      //获取半径
      var radius = that.getMax(this.boxHelper.getSize());
      //获取模型中心
      let center = this.boxHelper.getCenter();
      //设置镜头位置
      var cameraPos = new THREE.Vector3(
        center.x,
        center.y + radius,
        center.z + radius * 1.5
      );
      that.camera.position.copy(cameraPos);
      //控制器目标点,加载模型是异步，调整摄像头需要放到加载模型后
      this.spotLight.target = this.threeObj;
      let size = this.boxHelper.getSize();
      this.spotLight.position.set(
        (size.x * 3).toFixed(0),
        size.y.toFixed(0),
        0
      );
      this.controls.target = center;
    },

    //初始化灯光
    initLight() {
      let _ambient = new THREE.AmbientLight(0xffffff);
      this.camera.add(_ambient);
      this.spotLight = this.createSpotlight(0xffffff);
      this.lightHelper = new THREE.DirectionalLightHelper(this.spotLight);
      this.scene.add(this.spotLight);
      // this.scene.add(this.lightHelper);
    },

    createSpotlight(color) {
      var newObj = new THREE.DirectionalLight(color, 8);
      newObj.castShadow = true;
      newObj.angle = 0.3;
      newObj.penumbra = 0.442;
      newObj.decay = 2;
      newObj.distance = 350;
      return newObj;
    },

    getMax(val) {
      return Math.max(val.x, val.y, val.z);
    }
  }
};
</script>

<style type="text/less" lang="less" scoped>
@import "../../assets/styles/mixin.less";
#academy {
  height: 100%;
}
.academy-setting {
  position: fixed;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.btn {
  .center;
  font-size: 25px;
  text-align: center;
  .btn-item {
    background: @color-theme;
    color: #fff;
  }
  &.orange {
    background: @color-orange;
  }
}
.spotlight_item {
  color: #fff;
  width: 60%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-right: 20px;
  .spotlight-item-slider {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .slider-item {
      width: 35%;
    }
  }
}
.progress {
  position: fixed;
  top: 39%;
  left: 47%;
}
</style>
